const getScreenWidth = () =>
  Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)

export default getScreenWidth
